module.exports = __WEBPACK_EXTERNAL_MODULE_172__;


//////////////////
// WEBPACK FOOTER
// external "resx-strings"
// module id = 172
// module chunks = 0